"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bank_details_1 = __importDefault(require("./bank_details"));
var debts_1 = __importDefault(require("./debts"));
var my_company_1 = __importDefault(require("./my_company"));
var my_company_bank_details_1 = __importDefault(require("./my_company_bank_details"));
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @param {number} companyId A reference to a single company id
 * @class Companies
 * @classdesc Handles companies in Recover
 */
var Companies = /** @class */ (function () {
    function Companies(recover, companyId) {
        var _this = this;
        this.recover = recover;
        this.companyId = companyId;
        /**
         *
         *
         * @memberof Companies
         * @returns {Companies} Returns this class
         * @property {number} companyId A reference to a single company
         * @description Sets a company id for child classes
         */
        this.access = function (companyId) {
            _this.companyId = companyId;
            return _this;
        };
        /**
         *
         *
         * @memberof Companies
         * @returns {SuccessfulIndexCompanies} Returns a message and an index of all companies
         * @descrition Returns all Companies
         */
        this.index = function () {
            return _this.recover.request('/companies', 'GET', null, null);
        };
        /**
         *
         *
         * @memberof Companies
         * @returns {SuccessfulCreateCompany} Returns a message and the new company
         * @property {CreateCompany} company A JSON containing accounts_id(number), subscription_level_id(number), principal_user_id(number)
         * @description Creates a new company
         */
        this.create = function (company) {
            return _this.recover.request('/companies', 'POST', company, null);
        };
        /**
         *
         *
         * @memberof Companies
         * @returns {SuccessfulGetCompany} Returns a message and a single company
         * @property {number} id A reference to a single company
         * @description Returns a new company
         */
        this.get = function (id) {
            return _this.recover.request("/companies/" + id, 'GET', null, null);
        };
        /**
         *
         *
         * @memberof Companies
         * @returns {SuccessfulEditCompany} Returns a message and the edited company
         * @property {number} id A reference to a single company
         * @description Edits a company
         */
        this.edit = function (id, body) {
            return _this.recover.request("/companies/" + id, 'PUT', body, null);
        };
        /**
         *
         *
         * @memberof Companies
         * @inner
         * @returns {CompaniesBank} Returns a new instance of CompaniesBank
         * @property {Recover} recover A reference to the Recover class
         * @property {number} companyId A reference to a single company
         * @description Returns a new instance of the CompaniesBank class.
         */
        this.bank_details = function () { return new bank_details_1.default(_this.recover, _this.companyId); };
        /**
         *
         *
         * @memberof Companies
         * @inner
         * @returns Returns a new instance of CompaniesDebts
         * @property {Recover} recover A reference to the Recover class
         * @property {number} companyId A reference to a single company
         * @description Returns a new instance of the CompaniesDebts class
         */
        this.debts = function () { return new debts_1.default(_this.recover, _this.companyId); };
        /**
         *
         *
         * @memberof Companies
         * @inner
         * @returns Returns a new instance of MyCompany
         * @property {Recover} recover A reference to the Recover class
         * @description Returns a new instance of the MyCompany class
         */
        this.my_company = function () { return new my_company_1.default(_this.recover); };
        /**
         *
         *
         * @memberof Companies
         * @inner
         * @returns Returns a new instance of MyCompanyBankDetails
         * @property {Recover} recover A reference to the Recover class
         * @description Returns a new instance of the MyCompanyBankDetails class
         */
        this.my_company_bank_details = function () { return new my_company_bank_details_1.default(_this.recover); };
    }
    return Companies;
}());
exports.default = Companies;
